import React from 'react';

const Content = ({ items }) => (
  <div className="content">
      {
        items.map(i => {
          switch (i.type) {
            case 'p':
              return (<p>{i.content}</p>);
            case 'h4':
              return (<h4 className={i.style}>{i.content}</h4>);
            case 'h5':
              return (<h5 className={i.style}>{i.content}</h5>);
            case 'img':
              return (<img src={i.url} alt={i.alt} className={i.style}>{i.content}</img>);
            case 'hr':
              return (<hr />);
            case 'ul':
              return (
                <ul>
                  {
                    i.items.map(j => (
                      <li>{j.content}</li>
                    ))
                  }
                </ul>
              );
            default:
              return '';
          }
        })
      }
  </div>
);

export default Content;
